var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('app-sub-title',{attrs:{"text":"Módulo de Calidad"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }